// extracted by mini-css-extract-plugin
module.exports = {"textCyclerOverlay":"textCycler_textCyclerOverlay__V8W9c","textCyclerText":"textCycler_textCyclerText__iwrw4"};